import React, { useState } from 'react';
import { LightBulb } from 'iconoir-react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { formatPrice } from '../utils/currency';
import { getConciergesuggestions } from '../services/api';

function ConciergeModal({ show, onHide, onSelectProduct, brand }) {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [error, setError] = useState('');

  const suggestionCardStyle = {
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: '1px solid #dee2e6',
    borderRadius: '8px'
  };

  const suggestionCardHoverStyle = {
    ...suggestionCardStyle,
    borderColor: '#007bff',
    boxShadow: '0 2px 8px rgba(0,123,255,0.15)',
    transform: 'translateY(-1px)'
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    setLoading(true);
    setError('');
    setSuggestions([]);

    try {
      const data = await getConciergesuggestions(brand, message.trim());
      
      if (data.suggestions && Array.isArray(data.suggestions)) {
        setSuggestions(data.suggestions);
      } else {
        setError('Não foi possível obter sugestões. Tente novamente.');
      }
    } catch (err) {
      setError('Erro ao conectar com o serviço de sugestões. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleProductSelect = (suggestion) => {
    // Converter sugestão para formato de produto
    const produto = {
      id: suggestion.id,
      nome: suggestion.name,
      descricao: suggestion.description,
      valor: parseFloat(suggestion.price),
      imagem: null // API não retorna imagem
    };
    
    onSelectProduct(produto);
    handleClose();
  };

  const handleClose = () => {
    setMessage('');
    setSuggestions([]);
    setError('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          🤖 Concierge IA
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-3">
          Descreva o que você está procurando e nossa IA irá sugerir os melhores produtos para você!
        </p>
        
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>O que você gostaria de consumir?</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Ex: estamos no inverno, o que tu sugere para aquecer este frio?"
              disabled={loading}
            />
          </Form.Group>
          
          <div className="d-flex gap-2">
            <Button 
              variant="primary" 
              type="submit" 
              disabled={loading || !message.trim()}
              className="flex-grow-1"
            >
              {loading ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Buscando sugestões...
                </>
              ) : (
                '🔍 Buscar Sugestões'
              )}
            </Button>
            <Button variant="outline-secondary" onClick={handleClose}>
              Cancelar
            </Button>
          </div>
        </Form>

        {error && (
          <Alert variant="danger" className="mt-3">
            {error}
          </Alert>
        )}

        {suggestions.length > 0 && (
          <div className="mt-4">
            <h6 className="mb-3">✨ Sugestões para você:</h6>
            <div className="suggestions-list">
              {suggestions.map((suggestion, index) => (
                <div 
                  key={suggestion.id || index}
                  className="suggestion-card p-3 mb-3"
                  style={suggestionCardStyle}
                  onClick={() => handleProductSelect(suggestion)}
                  onMouseEnter={(e) => {
                    Object.assign(e.target.style, suggestionCardHoverStyle);
                  }}
                  onMouseLeave={(e) => {
                    Object.assign(e.target.style, suggestionCardStyle);
                  }}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="flex-grow-1">
                      <h6 className="mb-1 text-primary">{suggestion.name}</h6>
                      <p className="mb-2 text-muted small">{suggestion.description}</p>
                      {suggestion.reason && (
                        <p className="mb-2 small text-success">
                          <LightBulb className="me-1" />
                          {suggestion.reason}
                        </p>
                      )}
                    </div>
                    <div className="text-end">
                      <div className="fw-bold text-success">
                        {formatPrice(parseFloat(suggestion.price))}
                      </div>
                      <small className="text-muted">Clique para ver</small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ConciergeModal;
